module.exports = function (history, redirect) {    
    history.listen(location => {
        redirect(location.pathname)
    })
}